import { render, staticRenderFns } from "./ModalOptionsResource.vue?vue&type=template&id=7ac40111&"
import script from "./ModalOptionsResource.vue?vue&type=script&lang=js&"
export * from "./ModalOptionsResource.vue?vue&type=script&lang=js&"
import style0 from "./ModalOptionsResource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports